import PropTypes from 'prop-types';
import React from 'react';
import { LISTING_TYPES } from '../../../constants/constants';
import PriceWrapper from '../../../containers/price-wrapper';

const PropertyInfo = ({listing}) => {
  let titleSuffix = '';
  if (listing.agentSelect) {
    titleSuffix = 'Sold';
  } else if (listing.listingType === LISTING_TYPES.RENTAL) {
    titleSuffix = 'View Property for more details';
  } else {
    titleSuffix = <PriceWrapper priceInt={listing.price} displayPrice={listing.displayPrice}/>;
  }
  return (
    <span className="listing-info">
      <span className="title">{listing.title} - {titleSuffix}</span>
    </span>
  );
};

PropertyInfo.propTypes = {
  listing: PropTypes.object.isRequired
};

export default PropertyInfo;


// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/property-info.js